module.exports = __webpack_public_path__ + "img/portadaagua.58c3da9f.jpg";